module.exports = __webpack_public_path__ + "media/images/star_on-effa5ba8349af504bc2bda7dc66b63c5.svg";